import axios from 'axios';
import useSWR from 'swr';

const useLlmUsageSummary = (filters = {}) => {
  const searchParams = new URLSearchParams();

  if (filters.startDate) {
    const startOfDay = new Date(filters.startDate + 'T00:00:00.000');
    searchParams.set('start_ts_gte', startOfDay.toISOString());
  }
  if (filters.endDate) {
    const endOfDay = new Date(filters.endDate + 'T23:59:59.999');
    searchParams.set('start_ts_lte', endOfDay.toISOString());
  }

  const url = `/admin/llm-usage/summary?${searchParams.toString()}`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

const useLlmUsageTimeSeries = (filters = {}) => {
  const searchParams = new URLSearchParams();

  if (filters.startDate) {
    const startOfDay = new Date(filters.startDate + 'T00:00:00.000');
    searchParams.set('start_ts_gte', startOfDay.toISOString());
  }
  if (filters.endDate) {
    const endOfDay = new Date(filters.endDate + 'T23:59:59.999');
    searchParams.set('start_ts_lte', endOfDay.toISOString());
  }

  const url = `/admin/llm-usage/time-series?${searchParams.toString()}`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useLlmUsageSummary, useLlmUsageTimeSeries };
